import * as React from 'react';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { Permission, PrintPreviewDTO, PrintTemplateType, Res } from 'core/api';
import { SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { PrintFacade } from 'pos/facades';
import { Message, Modal } from 'core/ui-next/modal';
import { BackActionButton, Content, Filler, Footer, Header, PhoneDeviceActionButton, PhoneOnly, PosScreen } from 'pos/ui';
import { Box, VStack } from '@chakra-ui/react';

type Props = {
	preview: PrintPreviewDTO;
} & Modal.Actions<void>;

function PrintTrainingSession(props: Props) {
	const { preview, cancel, close } = props;

	const printTrainingSummary = async () => {

		if (SessionProvider.isSlave()) {
			await Message.show(Res.Msg.MSG_OPERATION_ONLY_VALID_IN_MASTER_POS());
			return;
		}

		await PrintFacade.printTraining();
	};

	const onCancel = React.useCallback(async () => cancel(), [cancel]);

	return (
		<PosScreen screenId={'PRINT_TRAINING_SESSION'} size={'small'} useKeyPad={false}>
			<Header title={Res.Web.PRINT_TRAINING_SUMMARY()} onClose={close} />
			<Content>
				<VStack width={'full'} height={'full'} padding={'4'}>
					<Box padding={'2'} border={'1px solid #ccc'} overflow={'auto'} width={'full'}>
						<UI.TemplatePrintPreview preview={preview} />
					</Box>
				</VStack>
			</Content>
			<Footer>
				<PhoneOnly>
					<BackActionButton action={onCancel} />
				</PhoneOnly>
				<Filler />
				<PhoneDeviceActionButton title={Res.Web.PRINT_TRAINING_SUMMARY_BTN()} image={Images.PrintTicket} action={printTrainingSummary} />
			</Footer>
		</PosScreen>
	);
}

declare global {
	interface CommandType {
		printTrainingSession: () => Promise<Result>
	}
}

Command.register('printTrainingSession', Preconditions.ensure(Permission.Pos_PrintTrainingSession), async (): Promise<Result> => {
	const preview: PrintPreviewDTO = {
		EscPosPreview: await PrintFacade.generateTrainingPreview(),
		EscPosNumberOfColumns: 0,
		RdlBase64Images: [],
		TemplateType: PrintTemplateType.EscPos
	};

	return Modal.show(PrintTrainingSession, { preview });
});
